import { useEffect, useState, useCallback } from 'react';
import axios from 'axios';

export function usePosts() {
  const [posts, setPosts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchArticles = useCallback(async (page = 1) => {
    setIsLoading(true);
    try {
      const response = await axios.get('/articles?page=' + page);

      return (response && response.data && response.data.rows ? response.data.rows.slice(0, 4) : []);
    } catch (err) {
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    async function getArticles() {
      const posts = await fetchArticles();

      setPosts(posts);
    }

    getArticles();
  }, [fetchArticles]);

  return { posts, isLoading };
}
